<template>
  <div class="home">
    <div id="weditor" ref="editor"></div>
  </div>
</template>

<script>
// 引入 wangEditor
import wangEditor from "wangeditor";
import { getQiniuToken } from "../api/api";

export default {
  watch: {
    value(val) {
      this.editor.txt.html(val);
    },
    content(val) {
      this.$emit("catchData", val);
    },
  },
  props: ["isAddEditor", "value", "content", "editorHeight"], // 接收父组件的方法
  data() {
    return {
      editor: null,
      editorData: "",
      qiniuToken: null,
      fileList: [],
      picList: [],
      num: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initEditor();
    });
    this.getQiniuToken();
  },
  methods: {
    initEditor() {
      this.editor = new wangEditor(this.$refs.editor);
      this.uploadVideo(); // 配置视频
      this.uploadImg(); // 配置图片
      this.setMenus(); // 配置菜单
      this.editor.config.onchange = () => {
        this.$emit("catchData", this.editor.txt.html());
      };
      this.editor.create(); // 创建
      this.editor.txt.html(this.content);
    },
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
        // if (res.data.success) {
        // } else {
        //   that.$message.error(res.data.msg);
        // }
      });
    },
    setMenus() {
      this.editor.config.colors = [
        "#000000",
        "#eeece0",
        "#1c487f",
        "#4d80bf",
        "#e54d42",
        "#f37b1d",
        "#fbbd08",
        "#8dc63f",
        "#39b54a",
        "#1cbbb4",
        "#0081ff",
        "#6739b6",
        "#9c26b0",
        "#e03997",
        "#a5673f",
        "#8799a3",
        "#333333",
        "#666666",
        "#aaaaaa",
        "#f1f1f1",
        "#ffffff",
        "#fadbd9",
        "#fde6d2",
        "#fef2ce",
        "#e8f4d9",
        "#d7f0db",
        "#d2f1f0",
        "#cce6ff",
        "#e1d7f0",
        "#ebd4ef",
        "#f9d7ea",
        "#aaaaaa",
        "#ede1d9",
        "#e7ebed",
      ];
      if (!this.isAddEditor) {
        this.editor.config.menus = [
          "head", // 标题
          "bold", // 粗体
          "fontSize", // 字号
          "fontName", // 字体
          "italic", // 斜体
          "underline", // 下划线
          "strikeThrough", // 删除线
          "foreColor", // 文字颜色
          "backColor", // 背景颜色
          "link", // 插入链接
          "list", // 列表
          "justify", // 对齐方式
          "quote", // 引用
          "undo", // 撤销
          "redo", // 重复
        ];
      }
    },
    uploadImg() {
      let that = this;
      that.editor.config.zIndex = 10;
      that.editor.config.height = that.editorHeight;
      that.editor.config.customUploadImg = (resultFiles, insertImgFn) => {
        if (Array.isArray(resultFiles)) {
          that.num = 0;
          that.fileList = resultFiles;
          that.updataImg(resultFiles[that.num]);
        } else {
          insertImgFn(resultFiles);
        }
      };
    },
    updataImg(file) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file, qiniuData)
        .then((res) => {
          that.num = that.num + 1;
          if (that.num < that.fileList.length) {
            that.updataImg(that.fileList[that.num]);
          } else {
            that.fileList = [];
          }
          that.editor.cmd.do(
            "insertHtml",
            '<img src="' + res + '" style="max-width:100%;"/>'
          );
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    uploadVideo() {
      let that = this;
      that.editor.config.zIndex = 10;
      that.editor.config.height = that.editorHeight;
      that.editor.config.customUploadVideo = (resultFiles, insertVideoFn) => {
        if (Array.isArray(resultFiles)) {
          that.num = 0;
          that.fileList = resultFiles;
          that.updataVideo(resultFiles[that.num]);
        } else {
          insertVideoFn(resultFiles);
        }
      };
    },
    updataVideo(file) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file, qiniuData)
        .then((res) => {
          that.num = that.num + 1;
          if (that.num < that.fileList.length) {
            that.uploadVideo(that.fileList[that.num]);
          } else {
            that.fileList = [];
          }
          that.editor.cmd.do(
            "insertHtml",
            '<video src="' +
              res +
              '" controls="controls" style="max-width:100%;">您的浏览器不支持 video 标签。</video>'
          );
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
  },
  beforeDestroy() {
    // 调用销毁 API 对当前编辑器实例进行销毁
    this.editor.destroy();
    this.editor = null;
  },
};
</script>

<style scope>
.home {
  width: 80%;
}
</style>
